"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RADIUS = exports.BORDER = void 0;
const RADIUS = exports.RADIUS = {
  S: '4px',
  M: '6px',
  L: '8px',
  XL: '16px'
};
const SHADOW = {
  M: '0px 4px 8px rgba(0, 0, 0, 0.1)'
};
const BORDER = exports.BORDER = {
  RADIUS,
  SHADOW
};